/* eslint-disable import/prefer-default-export */
import { Cookie } from '@vue-util/cookie';
import { cookies } from 'config';
import { get } from '@utils/api';
import { BagError } from '../errors';

/**
 * * Bag Service
 *
 * @description
 * Bag Service is responsible for fetching the bag data from the server,
 * potentially updating the bag data, and sending the bag data to the server.
 * ! Should be used only on the Client Side.
 */
export class BagService {
  get bagGuid() {
    return Cookie.get(cookies.bagGuid);
  }

  get bagUrl() {
    return `/xapi/bag/v1/${this.bagGuid}`;
  }

  /**
   * @returns {Promise<import('../bag').Bag>}
   */
  async fetch() {
    try {
      return this._mapResponse(await get(this.bagUrl));
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Failed to fetch bag data', error);
      throw new BagError('Failed to fetch bag data');
    }
  }

  /**
   * @param {import('../bag').BagResponse} response
   */
  _mapResponse(response) {
    return response.bag;
  }
}
